import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const ButtonSettingsV1 = z.object({
  text: z.string(),
  center: z.union([z.literal(true), z.literal(false)]),
  showLabel: z.union([z.literal(true), z.literal(false)]),
  borderRadius: z.number(),
  size: z.union([z.literal("regular"), z.literal("large")]),
  backgroundColor: z.string(),
})

export type TButtonSettingsV1 = z.infer<typeof ButtonSettingsV1>

export const ButtonElementV1 = z.object({
  id: z.string(),
  name: z.literal("button"),
  settings: ButtonSettingsV1,
  container: ContainerOptionsV1,
})

export type TButtonElementV1 = z.infer<typeof ButtonElementV1>

// Latest ---------------------
export const ButtonSettings = ButtonSettingsV1
export type TButtonSettings = TButtonSettingsV1
export const ButtonElement = ButtonElementV1
export type TButtonElement = TButtonElementV1
